type Props = {
  className?: string;
};

export function LoadingBar(_props: Props) {
  return 'Loading...';
}
